import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { Box } from '@material-ui/core';
import IssuesDesktop from './desktop/IssuesDesktop';
import IssuesMobile from './mobile/IssuesMobile';

import {
  getProducts,
  setSelectedProduct,
} from '../../../../../redux/actions/ProductActions';
import { getTracking } from '../../../../../redux/actions/TrackingActions';

import { ISSUES } from '../../../../../constants/Issues';
import { PURCHASE_ROUTE } from '../../../../../constants/Routes';

const useQuery = () => new URLSearchParams(useLocation().search);

const validateSelectedProduct = (filteredProducts, dispatch, history) => {
  if (filteredProducts.length) {
    const [selectedProduct] = filteredProducts;
    dispatch(setSelectedProduct(selectedProduct));
  } else history.push(PURCHASE_ROUTE);
};

const ReportIssue = (props) => {
  const { mobile } = props;
  const query = useQuery();
  const history = useHistory();
  const dispatch = useDispatch();
  const { products, selectedProduct: product } = useSelector(
    (state) => state.productReducer,
  );

  const { loading, error } = useSelector((state) => state.trackingReducer);

  useEffect(() => {
    if (!product?.orderId) dispatch(getProducts());
    if (
      product?.orderId &&
      !product?.dispatch?.dispatch_id &&
      !product?.errorTracking
    )
      dispatch(getTracking(product.orderId));
  }, [product]);

  useEffect(() => {
    if (products.length) {
      const orderId = query.get('orderId');
      const sku = query.get('sku');
      const filteredProducts = products.filter(
        (prod) => prod.orderId.toString() === orderId && prod.sku === sku,
      );
      validateSelectedProduct(filteredProducts, dispatch, history);
    }
  }, [products]);

  return (
    <Box>
      {!mobile && (
        <IssuesDesktop
          issues={ISSUES}
          product={product}
          loading={loading}
          error={error}
        />
      )}
      {mobile && (
        <IssuesMobile
          issues={ISSUES}
          product={product}
          loading={loading}
          error={error}
        />
      )}
    </Box>
  );
};

ReportIssue.propTypes = {
  mobile: PropTypes.bool,
};

export default ReportIssue;
